import React, { useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { Image, Button } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import logo from '../Images/logo_white.png';
import ikon_byggnader from '../Images/Meny-ikoner/ikon_byggnader.png';
import ikon_ekonomi from '../Images/Meny-ikoner/ikon_ekonomi.png';
import ikon_forvaltning from '../Images/Meny-ikoner/ikon_forvaltning.png';
import ikon_tidslinje from '../Images/Meny-ikoner/ikon_tidslinje.png';
import ikon_projekt from '../Images/Meny-ikoner/ikon_projekt.png';
import ikon_analys from '../Images/Meny-ikoner/ikon_analys.png';
import NavigationButton from "./NavigationButton";
import "./Navigation.css"

const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = getAuth();

    useEffect(() => {
        const user = auth.currentUser;
        if (user == null) {
            navigate('/');
        }
    }, [auth.currentUser, navigate]);

    const logOut = async () => {
        await signOut(auth)
            .then(() => {
                navigate('/home');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <div className="navigation-container">
            <div className="sidebar">
                <div className="logo-container">
                    <Image
                        src={logo}
                        className="logo"
                        onClick={() => navigate('/')}
                    />
                </div>

                <NavigationButton
                    label="Byggnader"
                    iconPath={ikon_byggnader}
                    isActive={location.pathname === '/map' || location.pathname === '/'}
                    onClick={() => navigate('/map')}
                />
                <NavigationButton
                    label="Ekonomi"
                    iconPath={ikon_ekonomi}
                    isActive={location.pathname === '/economy'}
                    onClick={() => navigate('/economy')}
                />
                <NavigationButton
                    label="Förvaltning"
                    iconPath={ikon_forvaltning}
                    isActive={location.pathname === '/management'}
                    onClick={() => navigate('/management')}
                />
                <NavigationButton
                    label="Tidslinje"
                    iconPath={ikon_tidslinje}
                    isActive={location.pathname === '/timeline'}
                    onClick={() => navigate('/timeline')}
                />
                <NavigationButton
                    label="Projekt"
                    iconPath={ikon_projekt}
                    isActive={location.pathname === '/projects'}
                    onClick={() => navigate('/projects')}
                />
                <NavigationButton
                    label="Analys"
                    iconPath={ikon_analys}
                    isActive={location.pathname === '/analysis'}
                    onClick={() => navigate('/analysis')}
                />

                <div className="customer-logo-container">
                    <img
                        src="/Images/customer_square_logo.png"
                        className="customer-logo"
                        alt="Customer Logo"
                    />
                </div>

                <span className="user-name">Saga Karlsson</span>
                <span className="user-organization">Västkuststiftelsen</span>

                <Button
                    variant="outline-light"
                    className="white-link-button logout-button"
                    onClick={logOut}
                >
                    Logga ut
                </Button>
            </div>

            <div className="main-content">
                <Outlet />
            </div>
        </div>
    );
};

export default Navigation;